import Vue from 'vue';

const replaceComponentName = "ugc-replace-image-control";
import { sessionKeys } from '@/data/constants';
import { validateImageRequirements } from '@/utils/imageValidator.utils';

export default Vue.extend({
  data() {
    return {

    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    isMobile() {
      return this.$store.getters["utils/returnScreenSize"].includes('mobile');
    },
    isApparel() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    activeViewComponent() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCView;
    },
    activeComponent() {
      const {
        activeComponent,
        activeSubComponent,
      } = this.$store.state.standardNavigation;

      if (this.isApparel) {
        return activeSubComponent !== ""
          ? `${activeComponent}/${activeSubComponent}`
          : activeComponent;
      }

      return this.$store.state.legacyNavigation.activeComponent;
    },
    tmallEnabled() {
      return this.$store.state.utils.configuration.integrations.tmall.enabled;
    },
    isMy() {
        if(typeof my !== 'undefined') {
         return true;
       } else {
        return false;
       }
    },
    componentName() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCComponent;
    },
    pdm() {
      return this.$store.state.utils.pdm;
    },
    minimumDimensions() {
      return this.pdm.components[this.componentName].ugc.image_requirements
        .minimum_dimensions;
    },
    maxSize() {
      return this.pdm.components[this.componentName].ugc.image_requirements
        .max_file_size;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
  },
  methods: {
    openNativeUploadDialog() {
      this.$refs[this.inputId].click();
    },
    onUploadClick() {
      if (this.logCustomizerEvents) this.setDataLayer();
      if (this.isGCC) return;
      // Set active index to UGC if not coming from almost done "Upload Another"
      if (this.activeViewComponent !== "ugc-almost-done" && this.activeViewComponent !== "new-ugc-almost-done") {
        this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "ugc");
      }

      this.isReplaceTool =
        this.$store.state.ugc.stateManager.activeControl ===
        replaceComponentName;

      if (!this.isReplaceTool) {
        this.$store.commit('ugc/tempData/SET_ACTIVE_UGC_COMPONENT', this.activeComponent);
      }

      this.$emit("before-upload");
      if (this.isReplaceTool) {
        this.$eventBus.$emit("reset-active-control");
      }

      if (this.shouldTermsConditionModalOpen()) {
        if(this.configuration.enableIntroVideo){
          this.$modal.show("introVideos");
        }else{
          this.$modal.show(this.configuration.ugc.enableNewUgcTermConditions ? "newTermsConditionModal" : "termsConditionModal");
        }
      } else {
        this.openNativeUploadDialog();
        if (this.activeViewComponent !== "ugc-almost-done" || this.activeViewComponent !== "new-ugc-almost-done") {
          this.$emit('click', 'uploadImage');
        }
      }
    },
    /**
     * @function setUGCImage
     * Grabs the image from the input field and sends it to validateImageProperties()
     */
     setUGCImage(e) {
      if (this.isReplaceTool) {
        this.$eventBus.$emit("set-active-control", replaceComponentName);
      }

      this.$modal.hide(this.configuration.ugc.enableNewUgcTermConditions ? "newTermsConditionModal" : "termsConditionModal");

      const file = e.target.files[0];
      const uploadedImage = (window.URL ? URL : webkitURL).createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        this.validateImageProperties(file, img);
      };
      img.src = uploadedImage;
    },
    setUGCImageTmall() {
      const _this = this;
      if(typeof my !== 'undefined') {
        my.onMessage = e => {
          if (e.imageUrl) {
            if (_this.isReplaceTool) {
              _this.$eventBus.$emit("set-active-control", replaceComponentName);
            }
            _this.$modal.hide(_this.configuration.ugc.enableNewUgcTermConditions ? "newTermsConditionModal" : "termsConditionModal");
            const img = new Image();
            img.onload = function() {
              const imgType = img.src.split(',')[0].split(':')[1].split(';')[0];
              const imgSize = (img.src.length * (3/4)) - 1;
              const imgHeight = img.height;
              const imgWidth = img.width;

              const file = {
                type: imgType,
                size: imgSize,
                width: imgWidth,
                height: imgHeight
              }
              _this.validateImageProperties(file, img);
            }
            img.src = e.imageUrl;
          }
        }
        my.postMessage({ 'action': 'inputFile' });
      }
      else {
        console.error('No miniapp my object was found');
      }
    },
    /**
     * @function validateImageProperties
     * Validates that the image is an accepted filetype and it has the correct size.
     * If invalid shows error modals
     */
     validateImageProperties(file, img) {
      const { imageStatus, isValidImage } = validateImageRequirements(file,img);

      if (!isValidImage) {
        this.showUploadError(imageStatus);
        return false;
      }

      const { tempData } = this.$store.state.ugc;
      if (tempData.features[tempData.activeUGCIndex].uploadAnother) {
          this.$store.commit("ugc/tempData/SET_UPLOAD_ANOTHER", null);
          this.tempFile = file;
          if (this.tmallEnabled && this.isMy) {
              this.tempFile = img;
          }

          this.$eventBus.$once("upload-another-assets-3d", this.onUploadAnotherFinish);
          this.$eventBus.$emit("upload-another-success");
          return true;
      }

      if ((this.tmallEnabled && this.isMy) || !file) {
          this.uploadImage(img);
          return true;
      }

      this.uploadImage(file, img.height, img.width, img.src);
      return true;
    },
    /**
     * @function uploadImage
     * Upload the image and save it in store
     */
     uploadImage(image, imgHeight = null, imgWidth = null, imgSrc = null) {
      const isReplaceTool = this.$store.state.ugc.stateManager.activeControl === "ugc-replace-image-control";
      // Restore UGC Feature when the image is replaced
      const ugcComp =  this.$recipe.getUGCComponents();
      const { tempData } = this.$store.state.ugc;

      if (isReplaceTool && tempData.features[tempData.activeUGCIndex].ugcFeature ) {
        this.$store.commit("ugc/tempData/SET_REPLACE_COMPONENT_FEATURE", this.componentName);
        if ( ugcComp && ugcComp.length == 1) this.$store.commit("ugc/tempData/SET_UGC_FEATURE", null);
      }

      this.$store.commit("ugc/tempData/IS_REPLACE_TOOL", isReplaceTool);
      this.$modal.show("uploadModal");
      this.$store.commit("ugc/stateManager/SET_LOADING", true);
      let imageObj = image;
      if (this.tmallEnabled && this.isMy) {
        imageObj = image.src;
      }
      this.$store.dispatch("ugc/UPLOAD", { inputFile: imageObj })
        .then(({ ugc_image_path: imagePath, temp_image_id, ugc_image_path_noresize }) => {
          this.$cookies.set(sessionKeys.ugcContactDetailsFilled, this.$store.state.UGCEntryPoint.contactDetails, 0);
          this.$cookies.set(sessionKeys.ugcTermsConditionsAccepted, true, 0);
          if (this.$store.state.UGCEntryPoint.optIn) {
            this.$cookies.set(sessionKeys.ugcOptIn, this.$store.state.UGCEntryPoint.optIn, 0);
          }
          this.$store.commit("ugc/stateManager/SET_LOADING", false);
          let fileFormat = "";
          if (this.tmallEnabled && this.isMy) {
            fileFormat = `${image.src.split(',')[0].split(':')[1].split(';')[0].split("/").pop()}`; //base64 image
          } else {
            fileFormat = image.type.split("/").pop();
          }
          const {
            recipe: tempRecipe,
            activeUGCComponent: componentName
          } = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex];
          if (
            !this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugc_size ||
            !tempRecipe ||
            !tempRecipe.components
          ) {
            this.$store.commit("ugc/tempData/SET_RECIPE", this.recipe_v2);
          }
          this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {
            imagePath,
            ugc_image_path_noresize,
            temp_image_id,
            imageFormat: fileFormat
          });

          if (this.useEcomDataLayerFormat) {
            this.$ugcDataLayer.logAnalyticsEvent({
              action: 'ugc',
              type: this.$ugcDataLayer.types.uploadAccepted
            });
          } else {
            dataLayer.push({
              ugcStep: 'uploadFinished',
              timeStamp: new Date().toISOString(),
              event: "ugcStep",
              eventCategory:'customs',
              eventAction:'UGC',
              eventLabel: 'uploadFinished'
            });
          }

          if (isReplaceTool && this.$store.state.ugc.stateManager.canvas) {
            this.$modal.hide("uploadModal");
            this.$store
              .dispatch("ugc/SET_CANVAS_IMAGE", {
                fabricCanvas: this.$store.state.ugc.stateManager.canvas,
                imageSrc: imagePath
              })
              .then(() => {
                this.$store.commit("ugc/tempData/SET_BACKGROUND");
                this.$store.state.ugc.stateManager.canvas.setBackgroundColor(
                  this.$store.state.utils.configuration.enableNewUgcModal ? "#f3f3f3" : "#ffffff"
                );
                this.$store.commit("ugc/tempData/SAVE_CROPPER_STATE", {
                  componentName
                });
                this.$store.commit("ugc/tempData/DISABLE_BG", false);
                this.$eventBus.$emit("ugc-tools-clear-all-selected", true);
                this.$store.commit("ugc/stateManager/APPLY_TILE_OR_POPART", false);
                this.$store.commit("ugc/tempData/CLEAR_ORIGINAL_IMAGE", this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].activeUGCComponent);
                this.$store.dispatch("ugc/stateManager/STORE_STEP");
              });
          } else {
            this.showOrSkipSizeSelector();
            if (this.isApparel) {
              //set recipe for Apparel ugc
              this.$eventBus.$emit('navigationActivateUpdatedFlag', false);
              /**Reset original graphic to load the new size */
              const { activeComponent, activeSubComponent } = this.$store.state.standardNavigation;
              const graphic = this.$store.getters["gdm/getGraphicByComponent"](activeComponent);
              const zoomPrecreated = this.$store.state.recipe.initRecipe?.components[activeComponent]?.sub_components?.[activeSubComponent]?.toolkit_options?.zoomValue;
              this.$store.commit("graphicsController/SET_ORIGINAL_GRAPHIC_VIEWBOX", {
                component: activeComponent,
                graphic: graphic,
                graphicViewZoomBox: {zoomValue: graphic.zoomValue || zoomPrecreated || "100",IPoint:{x:0,y:0}}
              });
              fetchAndInsertImageToGraphicSettings({
                src: imgSrc,
                componentID: this.$store.state.standardNavigation.activeComponent,
                subcomponentID: this.$store.state.standardNavigation.activeSubComponent,
                width: imgWidth,
                height: imgHeight,
                type: 'ugc',
                imgId: this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugc_image_id,
                imgUrl: this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugc_image_path_noresize ?? this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugc_image
              })
              .then(() => this.$store.dispatch('swatches/GET_RELATION_SWATCH_BY_FEATURE_ID', 'ugc')
                .then(({ swatches_not_allowed }) => {
                  this.$store.dispatch('buyPanel/GET_PRICE', { recipe: this.recipe_v2 });
                  this.$store.commit('graphicsController/SET_EDITOR_VISIBLE', true);
                  this.$customizerDataLayer.logAnalyticsEvent({
                    type: this.$customizerDataLayer.types.customizerUgcFlow,
                    eventLabel: 'Finished - Internal Flow',
                    forceEcomDataLayerFormat: true,
                  });
                  if (this.isMobile)
                    this.$store.commit('standardNavigation/IS_STANDARD_MENU_OPEN', false);
                  this.$store.commit(
                    'swatches/SET_DISABLED_SWATCHES_BY_FEATURE',
                    { swatches: swatches_not_allowed, feature: 'ugc' },
                  );
                }));
            }
            this.$eventBus.$emit("image-finished-loading");
            this.$emit("image-loaded", true);

          }
          this.onRemoved();
        })
        .catch(err => {
          console.error(err);
          this.showUploadError();
        });
    },
    shouldTermsConditionModalOpen() {
      if (this.configuration.ugc.forceUgcTermConditions && !this.$props.forceUpload) {
        return true;
      } else if (!this.termsConditionAccepted && !this.$cookies.get(sessionKeys.ugcTermsConditionsAccepted)){
        return true;
      }
      return false;
    },
    showOrSkipSizeSelector() {
      const { audienceSizes } = this.$store.state.utils;
      if (
        this.isApparel ||
        (audienceSizes &&
        audienceSizes.identifier &&
        audienceSizes.identifier.length === 1)
      ) {
        this.setDefaultSizeForOSFAModels();
      } else if(this.$store.state.utils.configuration.ugc.disableSizeSelector) {
        this.$modal.hide("uploadModal");
        this.$eventBus.$emit("load-size-assets", this.$ugc.getActiveUgcSize());
      } else {
        this.$modal.hide("uploadModal");
        const isNonCustomUgc = !this.$recipe.checkUGCByType({ customUGC: true});
        // the upload another is always reset to null when the dialog finishes
        const uploadedAnother = this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].uploadAnother !== null;
        // the size from temp or the recipe
        const ugcSize =
          this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].ugc_size ||
          this.$ugc.getActiveUgcSize(); 
        // checks for the size when uploading an image and also checks if is
        // GCC when starting the Customizer to show size selection dialog
        if (
          // doesn't have a size yet (blank model)
          !ugcSize
          // has size but it's not a Custom UGC, which means the current recipe
          // might have been saved with the default size
          || (ugcSize && isNonCustomUgc && !uploadedAnother)
          // is GCC and should show size selection dialog on start
          || this.submission_id
        ) {
          this.$modal.show(this.configuration.modals?.ugcSizeSelection ? "sizeSelectionModal" : "newSizeSelectionModal");
        } else {
          this.$eventBus.$emit("load-size-assets", ugcSize);
        }
      }
    },
    /**
     * @function showUploadError
     * Show the upload error modal.
     */
     showUploadError(imageStatus) {
      this.$modal.hide("uploadModal");
      this.$modal.show(this.configuration.modals.ugcErrorImg ? 'ugcUploadImageErrorModal' : 'uploadErrorModal', imageStatus);

      if (this.useEcomDataLayerFormat) {
        this.$ugcDataLayer.logAnalyticsEvent({
          action: 'ugc',
          type: this.$ugcDataLayer.types.uploadError
        });
      }
    },
    onRemoved() {
      if (this.$refs && this.$refs[this.inputId]) {
        this.$refs[this.inputId].value = "";
      }
    },
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {

  }
});
